import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: 'How do I receive the package after purchasing?',
  a: "You'll receive immediate access to everything so you can start using it right away — no waiting, no complicated steps."
}, {
  q: 'What level of dance teacher is this for?',
  a: "Dance Technique Teacher Ready™ is designed for dance instructors who teach beginner and intermediate teen and adult dancers in Jazz, Contemporary, and Musical Theatre. Whether you've been teaching for one year or fifteen, the library gives you structure, variety, and professional-level content you can use immediately."
}, {
  q: 'Does this work for dance teachers in any country?',
  a: 'Yes. The library is completely digital and accessible from anywhere in the world. Teachers in the US, UK, Australia, Canada, and across Europe are already using it.'
}, {
  q: 'Can I edit the material?',
  a: 'Yes. The content is provided in PDF format and is designed to be used directly as structured reference material. You can adapt the intensity, duration, and focus to suit your specific group.'
}, {
  q: 'What currency will I pay in?',
  a: "You can pay in your local currency. The amount adjusts automatically based on the country you're purchasing from."
}, {
  q: "What if it's not useful for me?",
  a: "If for any reason the library doesn't meet your teaching needs, simply contact us within 7 days for a full refund — no questions asked."
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-24 px-4 bg-dark-card" data-id="element-80">
      <div className="max-w-3xl mx-auto" data-id="element-81">
        <div className="text-center mb-16" data-id="element-82">
          <h2 className="text-3xl md:text-5xl font-serif font-bold" data-id="element-83">
            ❓ Frequently Asked Questions
          </h2>
        </div>

        <div className="space-y-4" data-id="element-84">
          {faqs.map((faq, index) => <div key={index} className="bg-black border border-dark-border rounded-xl overflow-hidden" data-id="element-85">
              <button className="w-full px-6 py-5 text-left flex items-center justify-between focus:outline-none" onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-86">
                <span className="font-bold text-lg text-white pr-8" data-id="element-87">
                  {faq.q}
                </span>
                <ChevronDown className={`text-gold transition-transform duration-300 shrink-0 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-88" />
              </button>

              <AnimatePresence data-id="element-89">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-90">
                    <div className="px-6 pb-5 text-gray-300 border-t border-dark-border/50 pt-4" data-id="element-91">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}